import { captureException as sentryCaptureException } from '@sentry/react';

export const captureException = (e: any) => {
  sentryCaptureException(e, {
    extra: {
      config: e.config,
      response: e.response
    }
  });
};
